import clsx from 'clsx';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TabSwitcher } from '../../../../shared/ui/tab-switcher/TabSwitcher';
import { selectCampaignCadencesSelectedChannel } from '../../../../features/campaign-cadences/store/campaignCadencesSlice';
import { CAMPAIGN_CADENCES_CHANNEL_TABS } from '../../../../features/campaign-cadences/constants/campaignCadencesTabs';
import styles from './CampaignCadencesChannelTabs.module.css';

export function CampaignCadencesChannelTabs({ onBeforeChange }) {
  const selectedChannel = useSelector(selectCampaignCadencesSelectedChannel);

  const tabs = useMemo(
    () =>
      CAMPAIGN_CADENCES_CHANNEL_TABS.map((tab) => ({
        key: tab.key,
        label: tab.label,
        isActive: tab.key === selectedChannel,
        onClick: () => onBeforeChange(tab.key),
      })),
    [selectedChannel, onBeforeChange],
  );

  return (
    <div className={clsx(styles.wrap)}>
      <TabSwitcher items={tabs} ariaLabel="Campaign cadences channel" />
    </div>
  );
}
